export default {
  dataIterator: {
    rowsPerPageText: '每頁記錄數：',
    rowsPerPageAll: '全部',
    pageText: '{0}-{1} 共 {2} 條',
    noResultsText: '沒有找到匹配記錄',
    nextPage: '下一頁',
    prevPage: '上一頁'
  },
  dataTable: {
    rowsPerPageText: '每頁行數：'
  },
  noDataText: '無可用數據',
  carousel: {
    prev: '以前的視覺',
    next: '下一個視覺'
  }
}
